export enum SettingType {
  PERSONAL = 'PERSONAL',
  GLOBAL = 'GLOBAL',
}
